<template>
  <a
    :href="href"
    @click.stop="openwebsite"
    target="_blank"
    rel="noopener"
  >
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: [
    'href'
  ],
  methods: {
    openwebsite (event) {
      if (this.environment === 'iOS-cordova') {
        var win = window.open(this.href, '_system')
        win.opener = null
        event.preventDefault()
        return
      } else {
        // open link normally
      }
    }
  },
  computed: {
    environment () {
      let env = ''
      if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
        env = 'iOS'
        if (window.cordova) {
          env += '-cordova'
        } else if (navigator.standalone) {
          env += '-webapp'
        } else if (navigator.userAgent.match(/CriOS/)) {
          env += '-chrome'
        }
      } else {
        env = 'Android'
        if (window.cordova) {
          env += '-cordova'
        }
      }
      return env
    }
  }
}
</script>